import React, { useEffect } from "react";
import { useState } from "react";

import axios from "axios";

import Card from "./Card";
import Search from "./Search";

import "../Styles/Home.css";

export default function Home() {
    const [searchTerm, setSearchTerm] = useState("");
    const [recettes, setRecettes] = useState([]);
    useEffect(() => {
    axios.get("https://anatole-sot.xyz/api/recettes-gibli/list-recipes.php")
    .then((response) => {
        setRecettes(response.data.data);
    })
    .catch((error) => {
        console.log(error);
    });
    }, []);
    return (
        <div className="Home">
            <Search searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
            <div className="Recettes">
                {
                    
                    recettes.length === 0 ? <h1>Chargement ...</h1> :
                    recettes.map((recette, index) => {
                        return (
                            recette.Title.toLowerCase().includes(searchTerm.toLowerCase())  ?<Card key={index} recette={recette} />:null
                        );
                    })
                }
            </div>
        </div>
    );
}